import React, {useContext, useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../shared/styles/search.css";
import search_icon from "../assets/svg/mingcute_search-line.svg";
import location_icon from "../assets/svg/tdesign_location.svg";
import previous from "../assets/svg/Prev.svg";
import nextPage from "../assets/svg/Next.svg";
import Filter from "./widgets/Filter";
import WalkIns from "./widgets/WalkIns";
import Ad from "./widgets/Ad";
import { dbKeys, path } from "../constant";
import { FunctionContext } from "../context/FunctionProvider";
function WalkInList() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 435);
  const {
    navigate,
    searchSubmit,
    onChangequery,
    query,
    page,
    walkinlist,
    generatePageNumber,
    t
  } = useContext(FunctionContext);
  // Extract query parameters
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsSmallMobile(window.innerWidth <= 425);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const generatePageNumbers = (totalItems, limit, offset = 4) => {
    
    const totalPages = Math.ceil(totalItems / limit); // Calculate total pages
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      if (totalPages!==(i)) {
        pages.push(
          Array.from({ length:  offset-totalPages<offset?totalPages:offset },(_, index) => i + index).slice(0, offset)
        )
     
    
      }else{
        pages.push( Array.from({ length:  1 },(_, index) =>totalPages).slice(0, offset))
     
        break
      }
   
      // console.log((offset-1),"pages",totalPages - ((offset-i)));
    }
// console.log("pages&&&&&&&&",pages,Math.round(page-offset<0?0:page-offset));
    return pages[Math.round(page-offset<0?0:page-offset)];
  };
  function generatePageUrl(walkinlist, page, query) {
    const totalPages = Math.ceil(walkinlist?.total / 5); // Assuming 5 items per page
    const currentPage = Number(page);
  
    if (totalPages < currentPage+1) {
      return "no";
    } else {
      navigate ("/" + path.searchPage(currentPage + 1, 5, query));
    }
  }
  function generatePreviousPageUrl(path, page, query) {
    const currentPage = Number(page);
  
    // Check if there is a previous page
    if (currentPage > 1) {
  
     navigate ("/"+ path.searchPage(currentPage - 1, 5, query))
   
    } else {
    navigate("/")
    }
  }
  
  return (
    <>
      <Header mobileflag={isSmallMobile} />
      <div className="search-div">
        {!isSmallMobile && (
          <div className="hero-section">
            <div className="head-h">
              <p className="hero-header  m-0">
                {t("walkinlistbannerheader1")}{" "}
                <span className="logo-color">{t("walkinlistbannerheader2")}</span>
              </p>
              <p className="hero-header-two m-0">
              {t("walkinlistbannerdescrip")}
              </p>
            </div>

            <div className="search-bar flex sa">
              <div className="input-w-icon flex">
                <img className="icon" alt="" src={search_icon}></img>
                <input
                  name={dbKeys.job_title}
                  onChange={(e) => onChangequery(e)}
                  value={query?.[dbKeys.job_title]}
                  className="b-none"
                  placeholder={t("jobtitle")}
                ></input>
              </div>
              <div className="input-w-icon flex">
                <img
                alt=""
                  className="icon"
                  style={{ height: "25px" }}
                  src={location_icon}
                ></img>
                <input
                 name={dbKeys.job_location}
                  onChange={(e) => onChangequery(e)}
                  value={query?.[dbKeys.job_location]}
                  className="b-none"
                  placeholder={t("joblocation")}
                ></input>
              </div>
              <button className="modern-button searchbutton mobile-full" onClick={()=>{searchSubmit(query)}}>
                <p className="m-0 p m-full">{t("jobsearch")}</p>
              </button>
            </div>
          </div>
        )}
        <div className="search-container">
          {!isSmallMobile && <Filter> </Filter>}
          {/* <Map></Map> */}
          <WalkIns walkinlist={walkinlist}></WalkIns>
          {!isMobile && <Ad></Ad>}
        </div>
       { walkinlist?.total&&<ul className="pagination">
          {/* <li className="page-no" onClick={()=>{setnext(next-1)}}>{"<<"} </li> */}
          <span className="page-no"  
          // href={"/#/" + path.searchPage(  Number(page)-1,5,query)}
          onClick={()=>{generatePreviousPageUrl(path, page, query) }}
          ><img src={previous} alt="previous">
          </img></span>
          {walkinlist &&
            generatePageNumbers(walkinlist?.total, 5).map((element) => (
              <a
                className={`page-no ${
                  element === Number(page) ? "active" : ""
                }`}
                href={"/#/" + path.searchPage(element, 5,query)}
              >
                {" "}
                {element}
              </a>
            ))}
          <span className={`page-no ${generatePageNumber(walkinlist?.total, 5).totalPages<Number(page)+1?"no_allowed":"" }  `} 
          onClick={()=>generatePageUrl(walkinlist, page, query)}
         // href={generatePageNumber(walkinlist?.total, 5).totalPages===Number(page)?"no":"/#/" + path.searchPage(  Number(page) + 1,5,query)} 
          ><img src={nextPage} alt="next" /></span>
          {/* <li className="page-no"onClick={()=>{setnext()}}>{">>"}</li> */}
        </ul>}
      </div>
      <Footer />
    </>
  );
}

export default WalkInList;
